import { getActiveHash, getAuthorizationMethod } from './cookieManager';

let api_base = process.env.REACT_APP_API_BASE;
const cms_api_base = 'https://dev-cms.stars-monitor.com/api';
export const api_url = `https://${api_base}.starsmonitor.com`;
let authServiceUrl = `https://${process.env.REACT_APP_AUTH_SERVICE_API_BASE}.stars-monitor.com`;

//dev points to dev auth
//stage and prod point to prod auth
//make env variable for auth

//for Michael testing, update with better stuff
export const fetchContracts = async (starsYear) => {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const url = `${cms_api_base}/contracts?stars_year=${starsYear}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${session_hash}`, 'Authorization-Method': authMethod },
    });
    return response.json();
  } catch (error) {
    console.error('Error fetching contracts', error);
  }
};

export const get = async (url, paramsObj) => {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  let urlParams = new URLSearchParams(paramsObj);
  let fullPath = paramsObj ? `${api_url}${url}?${urlParams.toString()}` : `${api_url}${url}`;
  return await fetch(fullPath, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
};

export const patch = async (url, data, paramsObj) => {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  let urlParams = new URLSearchParams(paramsObj);
  let fullPath = paramsObj ? `${api_url}${url}?${urlParams.toString()}` : `${api_url}${url}`;
  return await fetch(fullPath, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
    body: JSON.stringify(data),
  });
};

export const post = async (url, data, paramsObj) => {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  let urlParams = new URLSearchParams(paramsObj);
  let fullPath = paramsObj ? `${api_url}${url}?${urlParams.toString()}` : `${api_url}${url}`;
  return await fetch(fullPath, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
    body: JSON.stringify(data),
  });
};

export const deleteRequest = async (url, paramsObj) => {
  //untested no deletes yet
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  let urlParams = new URLSearchParams(paramsObj);
  let fullPath = paramsObj ? `${api_url}${url}?${urlParams.toString()}` : `${api_url}${url}`;
  return await fetch(fullPath, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
};

export async function loginUser(data) {
  const response = await fetch(authServiceUrl + '/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-api-key': `${process.env.REACT_APP_LOGIN_API_KEY}` },
    body: JSON.stringify({ email: data.username, password: data.password }),
  });
  return response;
}

export async function sendPasswordResetEmail(email) {
  const response = await fetch(authServiceUrl + '/pw_recovery/reset', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-api-key': `${process.env.REACT_APP_LOGIN_API_KEY}` },
    body: JSON.stringify({ email: email }),
  });
  return response;
}

export async function createPassword(body) {
  const response = await fetch(authServiceUrl + '/pw_recovery/update-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-api-key': `${process.env.REACT_APP_LOGIN_API_KEY}` },
    body: JSON.stringify(body),
  });
  return response;
}

export async function getAuthUser(token = null) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  if (token) {
    session_hash = token;
  }

  const response = await fetch(authServiceUrl + '/auth/session', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  if (response.status === 200) {
    return response.json();
  }
  return Promise.reject(response);
}

export async function fetchPlansWithContracts() {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  const response = await fetch(authServiceUrl + '/plans', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function fetchAccounts() {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  const response = await fetch(authServiceUrl + '/accounts', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function listAllPlans() {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  //no longer has data, can remove from call in component
  //only inlcude limit param if true
  const response = await fetch(authServiceUrl + '/contracts', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  let updated = await response.json();
  //should update the files to use the different return
  //keeping scope on the auth change as small as possible for now.
  updated = updated.map((plan) => {
    return { ...plan, contract_id: plan.code, contract_name: plan.name, totalEnrolled: 1 };
  });
  return updated;
}

export async function getPlanMetadata(data) {
  const response = await post('/plans/metadata', data);
  return response.json();
}

/* export async function getAccountStats(data) {
  let session_hash = getActiveHash();

  const response = await fetch(api_url + '/getAccountStats', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session_hash}` },
    body: JSON.stringify(data),
  });
  return response.json();
} */

export async function logout(data) {
  const response = await post('/logout', data);
  return response.json();
}

/* export async function createUser(data) {
  let session_hash = getActiveHash();

  const response = await fetch(api_url + '/createUser', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session_hash}` },
    body: JSON.stringify(data),
  });
  return response.json();
} */

/* export async function createAccount(data) {
  let session_hash = getActiveHash();

  const response = await fetch(api_url + '/createAccount', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session_hash}` },
    body: JSON.stringify(data),
  });
  return response.json();
} */

export async function testAuth() {
  const response = await get(api_url + '/test-auth');
  return response;
}

export async function scenariosCompare(body) {
  const response = await post('/compareScenarios', body);
  return response.json();
}

export async function listAllMeasures(params) {
  //params {monthly, contract_id, stars_year}
  //on monthly, don't include if false
  const response = await get('/measures/', params);
  return response.json();
}

export async function createScenario(data) {
  const response = await post('/createScenario', data);
  return response.json();
}
export async function listAllScenarios(data, params) {
  const response = await post('/listAllScenarios', data, params);
  return response.json();
}
export async function loadScenario(data) {
  const response = await post('/loadScenario', data);
  return response.json();
}

export async function modifyScenario(data) {
  const response = await post('/modifyScenario', data);
  return response.json();
}

export async function deleteScenario(data) {
  const response = await post('/deleteScenario', data);
  return response.json();
}

export async function getScenarioPermissionsByAuthUser() {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  const response = await fetch(authServiceUrl + '/permissions/scenarios', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  return response.json();
}

export async function getScenarioPermissionsByAccount(accountId) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  const response = await fetch(authServiceUrl + '/permissions/scenarios/account?account_id=' + accountId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  return response.json();
}

export async function addScenarioPermissions(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  return await fetch(authServiceUrl + '/permissions/scenarios', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
    body: JSON.stringify(body),
  });
}

export async function deleteScenarioPermission(permissionId) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  return await fetch(authServiceUrl + '/permissions/scenarios/' + permissionId, {
    method: 'Delete',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
}

export async function getUsers() {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();

  const response = await fetch(authServiceUrl + '/users', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  return response.json();
}

export async function getMonthlyPerformanceAnalysis(data) {
  const response = await post('/getMonthlyPerformanceAnalysis', data);
  return response.json();
}

export async function getMultiContractOverview(data, params) {
  const response = await post('/multi-contract/overview', { contract_list: data }, params);
  return response.json();
}

export async function getMultiContractTrendAnalysis(data, params) {
  const response = await post('/multi-contract/trend-analysis', data, params);
  return response;
}

export async function getMultiContractUnderPerformance(data) {
  const response = await post('/multi-contract/under-performance', data);
  return response.json();
}

export async function getMultiContractMeasureAnalysis(data) {
  const response = await post('/multi-contract/measure-analysis', data);
  return response.json();
}

export async function getProjectedStarsByMeasureSet(data) {
  const response = await post('/multi-contract/measure-set/projected-ratings', data);
  return response.json();
}

export async function getIndividualMeasureAnalysis(data, params) {
  const response = await post('/getIndividualMeasureAnalysis', data, params);
  return response.json();
}

export async function getCurrentMonthAlerts(data, params) {
  const response = await post('/getCurrentMonthAlerts', data, params);
  return response.json();
}

export async function calcVarianceFromTarget(data, params) {
  const response = await post('/calcVarianceFromTarget', data, params);
  return response.json();
}

export async function getMonthlyMeasureSetReview(data, params) {
  const response = await post('/getMonthlyMeasureSetReview', data, params);
  return response.json();
}

export async function rewardFactorOptimization(data, params) {
  const response = await post('/rewardFactorOptimization', data, params);
  return response.json();
}

export async function getMeasureSetQIPerformance(data) {
  const response = await post('/qi/measure-set-performance', data);
  return response.json();
}

export async function calcRFQIOptimization(data, params) {
  const response = await post('/qi/calc-rf-optimization', data, params);
  return response.json();
}

export async function scoreQITrend(data, params) {
  const response = await post('/qi/score-trend', data, params);
  return response.json();
}

export async function getQiRiskAnalysis(contractId, params) {
  return await get('/qi/risk-analysis/' + contractId, params);
}

export async function getQiOpportunityAnalysis(contractId, params) {
  return await get('/qi/opportunity-analysis/' + contractId, params);
}

export async function getProjectionDetail(h_code, params) {
  //params {hl_code, stars_year}
  const response = await get(`/projections/${h_code}`, params);
  return response.json();
}

export async function getAnalysisStarGaps(measureSet, contractId, params) {
  //params { stars_year }
  const response = await get(`/analysis/star-gaps/${measureSet}/${contractId}`, params);
  return response.json();
}

export async function getHistoricalCutpointAnalysis(data) {
  const response = await post('/getHistoricalCutpointAnalysis', data);
  return response.json();
}

export async function getTargetRefinementData(data) {
  const response = await post('/getTargetRefinementData', data);
  return response.json();
}
export async function getRewardFactorTargeting(contractId, params) {
  const response = await get(`/reward-factor/summary/${contractId}`, params);
  return response.json();
}
export async function getRewardFactorThresholds(params) {
  return await get(`/reward-factor/thresholds`, params);
}

export async function scoreSingleMeasure(data) {
  const response = await post('/scoreSingleMeasure', data);
  return response.json();
}

export async function updateCalcTargetRefinement(data) {
  const response = await post('/updateCalcTargetRefinement', data);
  return response.json();
}

export async function refreshScenario(data) {
  const response = await post('/refreshScenario', data);
  return response.json();
}



export async function saveScenario(data) {
  const response = await post('/saveScenario', data);
  return response.json();
}
export async function scenarioDownloadCsv(scenarioId, params) {
  return await post(`/csv/scenario-modeler/${scenarioId}`, {}, params);
}

export async function modifyScenarioMetadata(data) {
  const response = await post('/modifyScenarioMetadata', data);
  return response.json();
}

export async function setMeasureComment(data) {
  const response = await post('/measures/comment', data);
  return response.json();
}

export async function registerFileUpload(data) {
  //not tested yet
  let session_hash = getActiveHash();
  let modifiedData = data;

  modifiedData['active_hash'] = session_hash;

  const response = await fetch('/file-uploads/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session_hash}` },
    body: JSON.stringify(modifiedData),
  });
  return response.json();
}

export async function listFileUploads() {
  const response = await get('/file-uploads');
  return response.json();
}

export async function deleteFileUpload(data) {
  //not tested yet
  const response = await deleteRequest('/file-uploads/', data);
  return response.json();
}

export async function getOpportunityByPlan(contractId, stars_year) {
  const response = await post('/opportunityByPlan', { contract_list: contractId, stars_year: stars_year });
  return response.json();
}

export async function getOpportunityRisk(contractId, params) {
  const response = await get(`/analysis/opportunity-risk/${contractId}`, params);
  return response.json();
}
export async function getPartCAndDWeightedAverage(body, params) {
  const response = await post(`/analysis/part-c-and-d/weighted-average`, body, params);
  return response.json();
}
export async function getPartCAndDMeasuresByStar(body, params) {
  const response = await post(`/analysis/part-c-and-d/measures-by-star`, body, params);
  return response.json();
}
export async function getPartCAndDProjectedQi(body, params) {
  const response = await post(`/analysis/part-c-and-d/projected-qi`, body, params);
  return response.json();
}

export async function logUserIssue(data) {
  const response = await post('/monitor/log-user-issue', data);
  return response.json();
}

export async function getMetadataUploadsByMeasureSet(params) {
  const response = await get('/metadata/uploads-by-measure-set', params);
  return response.json();
}

export async function getHeiModelPerformance(body) {
  const response = await post('/hei/modelPerformance', body);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}
export async function getHEIModelPerformanceByScenarioId(scenarioId) {
  const response = await post('/hei/modelPerformance', { scenario_id: scenarioId });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getPp1ByContract(contractId, starsYear) {
  const response = await get(`/pp1/${contractId}?stars_year=${starsYear}`);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function pp1CreateOrUpdateComment({ body, params }) {
  const response = await patch(`/pp1/comment`, body, params);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getPp1CurrentByContract(contractId, starsYear) {
  const response = await get(`/pp1/current/${contractId}?stars_year=${starsYear}`);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function confirmPp1(body, params) {
  const response = await post(`/pp1/confirm`, body, params);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getMonthlyDataUploads() {
  const response = await get('/file-uploads');
  return response.json();
}

export async function fetchHeiScenarios(params) {
  const response = await get('/hei/scenarios', params);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function fetchHeiScenario(heiScenarioId) {
  const response = await get(`/hei/scenarios/${heiScenarioId}`);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function updateHeiScenario({ scenarioId, body }) {
  const response = await patch(`/hei/scenarios/${scenarioId}`, body);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function createHeiScenario(data) {
  const response = await post(`/hei/scenarios`, data);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function deleteHeiScenario(heiScenarioId) {
  const response = await deleteRequest(`/hei/scenarios/${heiScenarioId}`);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getLastUpdated(contractId, params) {
  const response = await get(`/file-uploads/${contractId}`, params);
  return response.json();
}

export async function rebateAnalysis(body) {
  const response = await post('/qbp/rebateAnalysis', body);
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function submitFeatureRequest(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(authServiceUrl + '/feedback/request-feature', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
    body: JSON.stringify(body),
  });
  return response;
}

export async function getContractsWithEnrollment(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`https://dev-cms.stars-monitor.com/contracts/membership`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': authMethod,
    },
  });
  return response.json();
}

export async function modifyScenarioStarsAdjustment(params) {
  const response = await post(`/modifyScenarioStarsAdjustment`, params);
  return response.json();
}

export async function getFilterMenuItems() {
  const response = await get(`/filter_menus`);
  return response.json();
}

export async function getConfig() {
  const response = await get('/config');
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

// Peer Anlysis APIs
export async function getMeasureRecordsAnalysis() {
  const response = await post(`/measure-records/analysis`);
  return response.json();
}

export async function getMeasureRecordsMeasureSet() {
  const response = await post(`/measure-records/measure-set`);
  return response.json();
}

export async function getStarsSummaryAverage() {
  const response = await post(`/stars-summary/avg`);
  return response.json();
}

export async function getAllContractsList(starsYear) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/contracts?stars_year=${starsYear}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  return response.json();
}

/*
Below takes the following body params:
{
  “contracts”: [“H0107", “H9207”],
  “starsYears”: [2022, 2023]
}
*/
export async function getIndividualScoresValuesForEachContractAndYear(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/filter`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below takes the following body params:
{
  “contracts”: [“H0107", “H9207”],
  “starsYears”: [2022, 2023]
}
*/
export async function getAverageStarsValuePerMeasureSet(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/measure-set`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below takes body as 
{
	contracts: ["H0107", "H9207"]
  years: [2022,2023]
}
*/
export async function getStarsSummary(body, starsYears) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/stars-summary?stars_year=${starsYears}`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below takes the following body params:
{
  “contracts”: [“H0107", “H9207”],
  “starsYears”: [2022, 2023]
}
*/
export async function getAverageOverallStarsForAllContracts(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/stars-summary/avg`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below take sthe following body params:
{
	"contracts": ["H2459", "H9207"],
	"starsYears": [2022],
	"measureSets": ["CAHPS"],
	"measureWeights": [1, 1.5]
}
*/
export async function getAverageScoreAndStarsByMeasure(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/average`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below take sthe following body params:
{
	"contract": "H2459",
	"starsYear": 2022,
	"measureSets": ["CAHPS"],
	"measureWeights": [1, 2, 3, 4, 5]
}
*/
export async function getMeasuresPercentileBySetAndWeight(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/percentiles`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getStarFrequency(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/stars-summary/frequency`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getDecliningMeasures(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/trends/measures/declining`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getMeasurePercentiles(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/percentiles`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

export async function getScoreChanges(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/trends/score/change`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below takes the following params
{
	"contract": "H2722",
	"starsYear": 2025
}
*/
export async function getNextYearWeight(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/variations/next-year-weight`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below takes the following params
{
	"contract": "H2722",
	"starsYear": 2025
}
*/
export async function getWeighChangeAverage(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/weight-change-avg`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below take sthe following params
{
    "contracts": [
        "H8889",
        "H5386",
        "H5302",
        ...
    ],
    "starsYears": [2025, 2023, 2024, 2022],
    "measureEQCode": "EQ01",
    "baseContract": "H8889"
}
*/
export async function getResultsAnalysis(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/results-analysis`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}

/*
Below accepts the following params
{
	"contracts": ["H2459", "H9207"],
	"starsYears": [2023, 2024, 2025],
	"measureSets": ["CAHPS", "Ops", "PDE", "HOS"], <--- optional
	"measureWeights": [1, 2, 3, 4, 5], <--- optional
    "measure": "HL01"
}
*/
export async function getIndividualMeasureRecords(body) {
  let session_hash = getActiveHash();
  const authMethod = getAuthorizationMethod();
  const response = await fetch(`${cms_api_base}/measure-records/individual`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session_hash}`,
      'Authorization-Method': `${authMethod}`,
    },
  });
  if (!response.ok) {
    throw new Error(response);
  }
  return response.json();
}
// End Peer Analysis APIs
